import type { AddressSource, PickedAddress, PostalLookup, PostalPlace } from "@flexfreight/ui";
import { api, ApiError } from "./client";

/* ZIP -> city/state and Google address suggestions through our own /v1 (the Google key stays on the server). */

const cache = new Map<string, PostalPlace | null>();

/** GET /v1/geo/postal/:code; null when the ZIP is unknown (staff type the city and state). */
export const lookupPostal: PostalLookup = async (code, country) => {
  const key = `${country}:${code.trim().toUpperCase()}`;
  if (cache.has(key)) return cache.get(key)!;
  try {
    const r = await api<PostalPlace>(`/v1/geo/postal/${encodeURIComponent(code.trim())}?country=${encodeURIComponent(country)}`);
    const place = { city: r.city, state: r.state, alternatives: r.alternatives ?? [] };
    cache.set(key, place);
    return place;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) {
      cache.set(key, null);
      return null;
    }
    throw e;
  }
};

export const addressSource: AddressSource = {
  suggest: (input, sessionToken) => api<{ enabled: boolean; suggestions: { placeId: string; text: string; main: string; secondary: string }[] }>("/v1/geo/autocomplete", { method: "POST", body: { input, sessionToken } }),
  details: async (placeId, sessionToken) =>
    (await api<{ address: PickedAddress }>(`/v1/geo/place/${encodeURIComponent(placeId)}?sessionToken=${encodeURIComponent(sessionToken)}`)).address,
};
